import { createFileRoute, useNavigate } from '@tanstack/react-router';
// Route options read the light search module; the page is code-split with the component.
import { ActivityPage } from '@/features/activity';
import { ActivitySearchSchema } from '@/features/activity/search';

/** Activity of the organisation: the feed, its filter kept in the address. */
export const Route = createFileRoute('/_auth/o/$orgId/activity')({
  validateSearch: (search) => ActivitySearchSchema.parse(search),
  component: ActivityRoute,
});

function ActivityRoute() {
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ActivityPage
      orgId={orgId}
      filter={search.filter}
      onFilterChange={(filter) => {
        void navigate({ search: () => ({ filter }), replace: true });
      }}
    />
  );
}
